export default __webpack_public_path__ + "static/media/H4007.2.16f16027.mp3";